import { AI_PLATFORM_LINGKEAGI, normalizeCatalogPlatformId } from '../constants/aiPlatforms'
import type { ImageGenParams } from '../types/timeline'

/**
 * 灵客 gpt-image-2 params 白名单（官方文档：size · quality · images · n）。
 * response_format 由后端固定 url。
 */
const LINGKE_PASSTHROUGH_KEYS = ['quality'] as const

export function isLingkeAgiImagePlatform(platformId: string): boolean {
  return normalizeCatalogPlatformId(platformId) === AI_PLATFORM_LINGKEAGI
}

export function buildLingkeImageOptions(
  apiSize: string,
  extraParamValues: Record<string, string>,
): Record<string, unknown> {
  const n = Math.min(10, Math.max(1, parseInt(extraParamValues.n ?? '1', 10) || 1))
  const opts: Record<string, unknown> = { size: apiSize, n }
  for (const key of LINGKE_PASSTHROUGH_KEYS) {
    const v = extraParamValues[key]?.trim()
    if (v) opts[key] = v
  }
  return opts
}

/** 写入时间线 params 快照，供 meta 行展示 */
export function snapshotLingkeDisplayParams(
  extraParamValues: Record<string, string>,
): Pick<ImageGenParams, 'quality'> {
  const out: Pick<ImageGenParams, 'quality'> = {}
  const quality = extraParamValues.quality?.trim()
  if (quality) out.quality = quality
  return out
}
